/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

        var offset;
        offset = 60;

        $('.nav-primary a[href*="#"]:not([href="#"])').click(function() {
          if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
            var target = $(this.hash);
            target = (target.length ? target : $('[name=' + this.hash.slice(1) +']'));
            if (target.length) {
              $('html,body').animate({
                scrollTop: target.offset().top-offset
              }, 1000);
              $('.navbar-collapse.in').removeClass("in");
              return false;
            }
          }
        });

        var timer = 0;

        function brsHighlight(){
          var searchText = $('#brs-filter').val().toLowerCase();
          $('.brs-container .brs-txt').highlight( searchText );
        }

        x=9;
        function limitBrsResults(){
          brsLength = $(".brs-container.result").length;
          $('.brs-container.result:gt('+x+')').hide();
          if(x >= brsLength){
              $('#load-more').hide();
          }
        }

        function moreBrsResults(){
          $('.brs-container.result').show();
          $('#load-more').hide();
        }

        function brsSearch(){
          $('.brs-txt').unhighlight();
          var searchText = $('#brs-filter').val().toLowerCase(),
              searchStringLength  = $('#brs-filter').val().length;
          if(searchStringLength > 2){
            $('.brs-content > .hidden').each(function () {
              var brsContent = $(this).parent(),
                  text  = $(this).text(),
                  textL = text.toLowerCase();

              if(textL.indexOf(searchText) !== -1){
                brsContent.parent().addClass("result").show();
              }else{
                brsContent.parent().removeClass("result").hide();
              }
              limitBrsResults();
              brsHighlight();
              });
          }else{
            $(".brs-container").addClass("result").show();
          }
          if( $('.brs-container.result').length > 10 ){
            $('#load-more').show();
          }
          $('#brs-count').text($('.brs-container.result').length);
        }

        $('#brs-filter').on('keyup', function() {
          if (timer) {
            clearTimeout(timer);
          }
          timer = setTimeout(brsSearch, 400);
        });

        $('body').on('blur', '#brs-filter', function(){
          brsHighlight();
        });

        $('.brs-txt').unhighlight();
        $('#brs-filter').val("");

        $('#load-more').on('click', moreBrsResults);
        $('.brs-container.result:gt('+x+')').hide();


        /* activate the carousel */
        $('#modalCarousel').carousel({interval:false});

        /* change modal title when slide changes */
        $('#modalCarousel').on('slid.bs.carousel', function () {
          $('.modal-title').html($(this).find('.active').attr("title"));
        });

        /* when clicking a thumbnail */
        $('.content .image-gallery a').click(function(e){
          e.preventDefault();
          $('#modalCarousel .carousel-inner').html('');

          /* copy loaded thumbnails into carousel */
          $(this).closest('.image-gallery').find('a').each(function(i) {
            /*var item = $('<div class="item"></div>');
            var style = $(this).attr('style');
            var title = $(this).attr("title");
            item.attr("title",title);
            item.attr("style",style);*/

            var item = $('<div class="item"><img src="'+
              $(this).attr("href")+'" alt="'+
              $(this).attr("title")+'" class="img-responsive"/></div>');

            if(parseInt($(this).data('index'))===0){ // set first item active
             item.addClass('active');
            }
            item.appendTo('#modalCarousel .carousel-inner');
          });


          var idx = $(this).data("index");
          var id = parseInt(idx);
          $('#gallery-modal').modal('show'); // show the modal
          $('#modalCarousel').carousel(id); // slide carousel to selected
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

        function postPaging(){
          var total_records = $( "#masonry-posts" ).data( "records" );
          var shown_records = $( "#masonry-posts article").length;
          if(total_records > shown_records){
            $('#pagination').show();
          }else{
            $('#pagination').hide();
          }
        }
        postPaging();

        $( 'body' ).on( 'click', '#pagination a', function (e) {
          e.preventDefault();
          var total_records = $( "#masonry-posts" ).data( "records" );
          var shown_records = $( "#masonry-posts article").length;
          var records_per_page =  $( "#masonry-posts" ).data( "records-page" );
          var new_link = (shown_records / records_per_page) + 1;
          var link = $(this).attr('href').slice(0, -1);

          var paths = link.split('/');
          paths[ paths.length-1 ] = new_link; // new value
          link = paths.join('/');

          $.get( link, function (data){
            $( data ).find( "#masonry-posts article" ).appendTo( "#masonry-posts" );
          }).done(function(data){postPaging();});

        });


        $( 'body' ).on('click', '#masonry-toggle li a', function(e){
          e.preventDefault();
          $('#masonry-toggle li').removeClass('active');
          $(this).parent().addClass('active');
          var masonryPostsClass = $(this).attr('id');
          $('#masonry-posts').removeClass();
          $('#masonry-posts').addClass(masonryPostsClass);
        });

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
        (function(){

          $('.block-carousel .item').each(function(){
            var itemToClone = $(this);

            for (var i=1;i<3;i++) {
              itemToClone = itemToClone.next();

              // wrap around if at end of item collection
              if (!itemToClone.length) {
                itemToClone = $(this).siblings(':first');
              }

              // grab item, clone, add marker class, add to collection
              itemToClone.children(':first-child').clone()
                .addClass("cloneditem-"+(i))
                .appendTo($(this));
            }
          });
        }());

      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
        if($('#modal-popup').hasClass('trigger')){
          $('#modal-popup').modal('show');
        }
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    },
    'upcoming_events': {
      init: function() {
      },
      finalize: function() {
        var options = {
          events_source: '/events/calendar/json/',
          view: 'month',
          tmpl_path: "/wp-content/themes/nbn/calendar/tmpls/",
          tmpl_cache: false,
          time_start: '06:00',
          time_end: '22:00',
          time_split: '30',
          /* "iframe" (default), "ajax" or "template" */
          modal: null, /*"#events-modal",*/
          modal_type: "iframe",
          onAfterEventsLoad: function(events) {
            if(!events) {
              return;
            }
            var list = $('#eventlist');
            list.html('');

            $.each(events, function(key, val) {
              $(document.createElement('li'))
                .html('<a href="' + val.url + '">' + val.title + '</a>')
                .appendTo(list);
            });
          },
          onAfterViewLoad: function(view) {
            $('.calendar-title h3').text(this.getTitle());
            $('.btn-group button').removeClass('active');
            $('button[data-calendar-view="' + view + '"]').addClass('active');
          },
          classes: {
            months: {
              general: 'label'
            }
          }
        };

        var calendar = $('#calendar').calendar(options);

        $('.btn-group button[data-calendar-nav]').each(function() {
          var $this = $(this);
          $this.click(function() {
            calendar.navigate($this.data('calendar-nav'));
          });
        });

        $('.btn-group button[data-calendar-view]').each(function() {
          var $this = $(this);
          $this.click(function() {
            calendar.view($this.data('calendar-view'));
          });
        });

        $('#first_day').change(function(){
          var value = $(this).val();
          value = value.length ? parseInt(value) : null;
          calendar.setOptions({first_day: value});
          calendar.view();
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.

/*
 * jQuery Highlight plugin
 *
 * Based on highlight v3 by Johann Burkard
 * http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html
 *
 * Code a little bit refactored and cleaned (in my humble opinion).
 * Most important changes:
 *  - has an option to highlight only entire words (wordsOnly - false by default),
 *  - has an option to be case sensitive (caseSensitive - false by default)
 *  - highlight element tag and class names can be specified in options
 *
 * Usage:
 *   // wrap every occurrance of text 'lorem' in content
 *   // with <span class='highlight'> (default options)
 *   $('#content').highlight('lorem');
 *
 *   // search for and highlight more terms at once
 *   // so you can save some time on traversing DOM
 *   $('#content').highlight(['lorem', 'ipsum']);
 *   $('#content').highlight('lorem ipsum');
 *
 *   // search only for entire word 'lorem'
 *   $('#content').highlight('lorem', { wordsOnly: true });
 *
 *   // don't ignore case during search of term 'lorem'
 *   $('#content').highlight('lorem', { caseSensitive: true });
 *
 *   // wrap every occurrance of term 'ipsum' in content
 *   // with <em class='important'>
 *   $('#content').highlight('ipsum', { element: 'em', className: 'important' });
 *
 *   // remove default highlight
 *   $('#content').unhighlight();
 *
 *   // remove custom highlight
 *   $('#content').unhighlight({ element: 'em', className: 'important' });
 *
 *
 * Copyright (c) 2009 Bartek Szopka
 *
 * Licensed under MIT license.
 *
 */

jQuery.extend({
    highlight: function (node, re, nodeName, className) {
        if (node.nodeType === 3) {
            var match = node.data.match(re);
            if (match) {
                var highlight = document.createElement(nodeName || 'span');
                highlight.className = className || 'highlight';
                var wordNode = node.splitText(match.index);
                wordNode.splitText(match[0].length);
                var wordClone = wordNode.cloneNode(true);
                highlight.appendChild(wordClone);
                wordNode.parentNode.replaceChild(highlight, wordNode);
                return 1; //skip added node in parent
            }
        } else if ((node.nodeType === 1 && node.childNodes) && // only element nodes that have children
                !/(script|style)/i.test(node.tagName) && // ignore script and style nodes
                !(node.tagName === nodeName.toUpperCase() && node.className === className)) { // skip if already highlighted
            for (var i = 0; i < node.childNodes.length; i++) {
                i += jQuery.highlight(node.childNodes[i], re, nodeName, className);
            }
        }
        return 0;
    }
});

jQuery.fn.unhighlight = function (options) {
    var settings = { className: 'highlight', element: 'span' };
    jQuery.extend(settings, options);

    return this.find(settings.element + "." + settings.className).each(function () {
        var parent = this.parentNode;
        parent.replaceChild(this.firstChild, this);
        parent.normalize();
    }).end();
};

jQuery.fn.highlight = function (words, options) {
    var settings = { className: 'highlight', element: 'span', caseSensitive: false, wordsOnly: false };
    jQuery.extend(settings, options);

    if (words.constructor === String) {
        words = [words];
    }
    words = jQuery.grep(words, function(word, i){
      return word !== '';
    });
    words = jQuery.map(words, function(word, i) {
      return word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
    });
    if (words.length === 0) { return this; }

    var flag = settings.caseSensitive ? "" : "i";
    var pattern = "(" + words.join("|") + ")";
    if (settings.wordsOnly) {
        pattern = "\\b" + pattern + "\\b";
    }
    var re = new RegExp(pattern, flag);

    return this.each(function () {
        jQuery.highlight(this, re, settings.element, settings.className);
    });
};
